import React, { Component } from 'react'
import Select from 'react-select'

class AccountType extends Component {
    constructor() {
        super()
        this.state = {
            AccountTypeList:[ {"label":"SAVINGS","value":"SAVINGS"},{"label":"CURRENT","value":"CURRENT"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }
    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.AccountTypeList}
                placeholder="Select Account Type"
                onChange={(e) => { (e) ? this.props.accountTypeChange(e) : this.props.accountTypeChange([])}}
                />
            </div>
        )
    }
}

export default AccountType


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/AccountType.js